import React from 'react';
import { Outlet } from 'react-router-dom';
import utils from 'utils';
import routes from './routes';
import DashContentWrapper from '../../components/DashContentWrapper';

import './Users.styles.scss';

const usersSubrouterRoutes = utils.createNavRoute(routes);

export const USEERS_ROUTER_LIMIT = '10';

const UsersRouter: React.FC = () => {
  return (
    <div className="users-router subrouter-wrapper">
      <DashContentWrapper routes={usersSubrouterRoutes}>
        <Outlet />
      </DashContentWrapper>
    </div>
  );
};

export default UsersRouter;
